import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;
  const isServicesActive = () => {
    return location.pathname === '/services' || 
           location.pathname === '/rentals' || 
           location.pathname === '/enzymes';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsServicesOpen(false);
  };

  const toggleServices = (e) => {
    e.preventDefault();
    setIsServicesOpen(!isServicesOpen);
  };

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="top-bar-container">
          <div className="top-bar-left">
            <span className="top-bar-icon">🕐</span>
            <span>24/7 Emergency Septic Services</span>
          </div>
          <div className="top-bar-right">
            <span className="top-bar-icon">📞</span>
            <a href="tel:903-218-8281">903-218-8281</a>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <Link to="/" className="nav-logo" onClick={closeMenu}>
            <img src="/AASP_Logo.png" alt="All Around Septic Pumping Logo" className="logo-img" />
          </Link>
          
          <button 
            className={`nav-toggle ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li>
              <Link 
                to="/" 
                className={`nav-link ${isActive('/') ? 'active' : ''}`}
                onClick={closeMenu}
              >
                Home
              </Link>
            </li>
            <li className="nav-item-with-dropdown">
              <a 
                href="#services" 
                className={`nav-link ${isServicesActive() ? 'active' : ''} ${isServicesOpen ? 'dropdown-open' : ''}`}
                onClick={toggleServices}
              >
                Services
                <span className="dropdown-arrow">▼</span>
              </a>
              <ul className={`dropdown-menu ${isServicesOpen ? 'open' : ''}`}>
                <li>
                  <Link 
                    to="/services" 
                    className={`dropdown-link ${isActive('/services') ? 'active' : ''}`}
                    onClick={closeMenu}
                  >
                    Services
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/rentals" 
                    className={`dropdown-link ${isActive('/rentals') ? 'active' : ''}`}
                    onClick={closeMenu}
                  >
                    Rentals
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/enzymes" 
                    className={`dropdown-link ${isActive('/enzymes') ? 'active' : ''}`}
                    onClick={closeMenu}
                  >
                    Enzymes
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link 
                to="/about" 
                className={`nav-link ${isActive('/about') ? 'active' : ''}`}
                onClick={closeMenu}
              >
                About
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
                onClick={closeMenu}
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navigation;

